
import { NewsComponent } from "../news/news.component"
import { NewsListComponent } from "../news/newslist.component"
import { NewsFilterComponent } from "../news/news-filter.component"
import { LocalNavComponent } from "../local-nav.component"
import { GlobalSearchComponent } from '../global-search/components/search/global-search.component'
import { AssetScreenerComponent } from '../assetScreener/components/assetScreener.component'
import { EventAttendeesComponent } from '../eventAttendees/components/eventAttendees.component'
import { PaymentsComponent } from '../profile/Payments/Payments.component'
import { EmailFormComponent } from '../profile/EmailForm/EmailForm.component'
import { DeleteAccountComponent } from '../profile/DeleteAccount/DeleteAccount.component'
import { PushToggleComponent } from '../push/push-toggle.component'
import { PushCtaComponent } from '../push/push-cta.component'
import { GlobalSearchOpener } from '../global-search/components/opener/global-search-opener.component'
import { SearchHitComponent } from '../global-search/components/search-hit/search-hit.component'
import { TokenDataContainer } from "../tokenData/components/tokenDataList"
import { TokenDataItem } from "../tokenData/components/tokenDataItem"
import { SigninComponent } from "../auth/components/signin/signin.component"
import { SignupComponent } from "../auth/components/signup/signup.component"
import { AuthState } from "../auth/components/auth-state.component"
import { NumberComponent } from "../numbers/number.component"
import { NewsletterManager } from "../newsletters/newsletter.component"
import { SignoutButtonComponent } from "../auth/components/signout/signout-btn.component"
import { ArticleAnchorsComponent } from "../content/articles/anchors/anchors.component"
import { ArticleReadingTimeComponent } from "../content/articles/reading-time/reading-time.component"

// import { ChartManager } from "../charts/charts.manager"
import { ArticlePremiumContent } from "../content/articles/text/premium-content.component"
import { ReportEmbed } from "../content/reports/embed.component"
import { PersonProfile } from "../people/person-profile.component"
import { CompanyPeopleComponent } from "../people/company-people.component"
import { AiChatComponent } from "../chat/ai-chat.component"

const components = [
  // Auth
  { name: 'tbw-signin', component: SigninComponent },
  { name: 'tbw-signup', component: SignupComponent },
  { name: 'tbw-auth-state', component: AuthState },
  { name: 'tbw-signout-btn', component: SignoutButtonComponent },

  // Dev
  { name: 'tbw-local-nav', component: LocalNavComponent },

  // News
  { name: 'tbw-news', component: NewsComponent },
  { name: 'tbw-news-list', component: NewsListComponent },
  { name: 'tbw-news-filter', component: NewsFilterComponent },

  // Token Data
  { name: 'tbw-token-data-container', component: TokenDataContainer },
  { name: 'tbw-token-data-item', component: TokenDataItem },

  // Asset Screener
  { name: 'tbw-asset-screener', component: AssetScreenerComponent },

  // Event Attendees
  { name: 'tbw-event-attendees', component: EventAttendeesComponent },

  // Payments
  { name: 'tbw-payments', component: PaymentsComponent },
  { name: 'tbw-email-form', component: EmailFormComponent },
  { name: 'tbw-delete-account', component: DeleteAccountComponent },
  { name: 'tbw-push-toggle', component: PushToggleComponent },
  { name: 'tbw-push-cta', component: PushCtaComponent },

  // Global Search
  { name: 'tbw-global-search-opener', component: GlobalSearchOpener },
  { name: 'search-hit', component: SearchHitComponent },
  { name: 'tbw-global-search', component: GlobalSearchComponent },

  // Newsletter
  { name: 'tbw-nl-manager', component: NewsletterManager },
  { name: 'tbw-number', component: NumberComponent },

  // Article Anchors
  { name: 'tbw-anchors', component: ArticleAnchorsComponent },
  { name: 'tbw-reading-time', component: ArticleReadingTimeComponent },
  { name: 'tbw-premium-content', component: ArticlePremiumContent },
  { name: 'tbw-report-embed', component: ReportEmbed },

  // People profile (data from the API, not the Webflow template)
  { name: 'tbw-person-profile', component: PersonProfile },
  { name: 'tbw-company-people', component: CompanyPeopleComponent },

  // AI Chat
  { name: 'tbw-ai-chat', component: AiChatComponent },
]

export const registerComponents = () => {
  components.forEach(component => {
    customElements.define(component.name, component.component)
  })
}